import { render, staticRenderFns } from "./userDetail.vue?vue&type=template&id=10320ea5&scoped=true"
import script from "./userDetail.vue?vue&type=script&lang=js"
export * from "./userDetail.vue?vue&type=script&lang=js"
import style0 from "./userDetail.vue?vue&type=style&index=0&id=10320ea5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10320ea5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10320ea5')) {
      api.createRecord('10320ea5', component.options)
    } else {
      api.reload('10320ea5', component.options)
    }
    module.hot.accept("./userDetail.vue?vue&type=template&id=10320ea5&scoped=true", function () {
      api.rerender('10320ea5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/userManagement/userList/userDetail.vue"
export default component.exports